import React from 'react'

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  return (
    <div>
      <footer className="footer">
        <h1> Get Started </h1>
        <p className="quote"> Eat your favourite meal, save time, and network with Foodies </p>

        <button className="upbtn" onClick={scrollToTop}> <i className="fas fa-chevron-up" />  </button>

      </footer>
      <footer className="main-footer">
        <div className="footer-container">
          <div className="inner">
            <div>
              <strong> Foodies </strong>
              <a href="https://www.edamam.com/"> Edamam </a>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSeqJ9oowm-PpbdhieT6c8-9geW2gLGywC-M3yFa2InWdfDYCA/viewform?fbzx=4259953578556890977"> Give Feedback </a>
              <a href = "https://logomakr.com/"> Logo Makr </a>
              <a href="#"> Recipes </a>
            </div>
            <div className = "company">
              <strong> OUR COMPANY </strong>
              <a href="#"> Instagram </a>
              <a href="#"> Facebook </a>
              <a href="#"> New Look </a>
            </div>
            <div className = "help">
              <strong> HELP </strong>
              <a href="#"> Find an answer </a>
              <a href="#"> Help Centre </a>
            </div>
          </div>
          <div className="footer-2">
            <strong> Contact </strong>
            <a href="mailto: kangjohn00000@gmail.com"> kangjohn00000@gmail.com </a>
          </div>
        </div>


      </footer>

      <footer className="footer2">

        <a href="#"> &#169; Foodies </a>
        <a href="#">Terms and Conditions</a>
        <a href="#">Privacy </a>

      </footer>
    </div>
  )
}
